/**
 * Products for a "Load more" list: the first page replaces the list, later
 * pages are appended, skipping products already shown.
 */
export const mergeProducts = (previous, next, page) => {
  if (page === 0) return next;
  const seen = new Set(previous.map((product) => product.id));
  return [...previous, ...next.filter((product) => !seen.has(product.id))];
};

/** Product names from the API can contain HTML entities such as &amp;. */
export const decodeEntities = (text = "") => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

/**
 * Final price, the struck-through original and the discount badge value.
 * An active Sale collection discount applies on top of the sale price
 * (or the regular price when there is none).
 */
export const getPricing = (product) => {
  const original = Number(product.regularPrice) || 0;
  const salePrice = Number(product.salePrice) || 0;
  const configDiscount = product.configuration?.Sale?.collectionConfiguration?.discount;
  const hasConfig =
    product.configuration?.Sale?.configStatus === "active" && configDiscount != null;
  let price = salePrice || original;
  if (hasConfig) price *= 1 - Number(configDiscount) / 100;
  const discountPercentage =
    original > 0 ? Math.round(((original - price) / original) * 100) : 0;
  return { price, original, discountPercentage };
};
